import { render, staticRenderFns } from "./OwnerInfoForm.vue?vue&type=template&id=4f9e5666&scoped=true&"
import script from "./OwnerInfoForm.vue?vue&type=script&lang=js&"
export * from "./OwnerInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInfoForm.vue?vue&type=style&index=0&id=4f9e5666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e5666",
  null
  
)

export default component.exports